import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

import {
  ref,
  provide,
  reactive,
  watch,
  CSSProperties,
} from 'vue'
import SliderButton from './SliderButton.vue'

type TSliderInitData = {
  valueCache: number
  innerStyle: CSSProperties
  isSliderButtonDragging: boolean
  isHovering: boolean
}


export default /*#__PURE__*/_defineComponent({
  props: {
  showTooltip: {
    type: Boolean,
    default: false,
  },
  vertical: Boolean,
  marks: {
    type: Array,
    default: function _default () {
      return []
    },
  },
  scales: {
    type: Array,
    default: function _default () {
      return [0, 100]
    },
  },
  value: Number,
  disabled: Boolean,
  renderMarksLabel: Function,
  renderMarks: Function,
  formatTooltip: {
    type: Function,
    default: function _default (val) {
      return val
    },
  },
},
  emits: ['release', 'input', 'change', 'update:value'],
  setup(__props, { emit }) {

const props = __props

const sliderInitData = {
  valueCache: 0,
  innerStyle: {
    height: 0,
    width: 0,
  },
  isSliderButtonDragging: false,
  isHovering: false,
}

const slider = ref(null)
const button = ref<{ handleClick: Function } | null>(null)

const data = reactive<TSliderInitData>(sliderInitData)


provide('slider', {
  ...props,
  refs: { slider: slider },
})

watch(() => props.value, () => {
  data.valueCache = Number(props.value)
}, { immediate: true })

const isSliderButtonDragging = ref(false)

const handleSliderButtonDragEnd = () => {
  isSliderButtonDragging.value = false
  handleRelease(data.valueCache)
}

const handleRelease = (value: number) => {
  data.valueCache = value
  emit('release', value)
  emit('update:value', value)
}

const handleSliderButtonDragStart = () => {
  isSliderButtonDragging.value = true
}

const handleUpdate = (value: number) => {
  data.valueCache = value
  emit('input', value)
  emit('change', value)
  emit('update:value', value)
}

const handleClick = (e) => {
  if (props.disabled) return
  button?.value?.handleClick(e)
}

const handleUpdateInnerStyle = (moved: number) => {
  data.innerStyle = Object.assign({}, { [props.vertical ? 'height' : 'width']: moved })
}

const handleMouseEnter = () => {
  data.isHovering = true
}

const handleMouseLeave = () => {
  data.isHovering = false
}

// const handleClickMark = (mark) => {
//   if (props.disabled) return
//   let value =  0
//   if (mark && typeof mark === 'object') {
//     value = mark.value
//   } else {
//     value = mark
//   }
//   emit('input', value)
// }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['td-slider', props.vertical ? 'is-vertical' : '', __props.disabled ? 'is-disabled' : '']),
    ref_key: "slider",
    ref: slider
  }, [
    _createElementVNode("div", {
      class: "td-slider__bar",
      onClick: handleClick
    }, [
      _createElementVNode("div", {
        class: "td-slider__bar-inner",
        style: _normalizeStyle([_unref(data).innerStyle])
      }, [
        (props.showTooltip)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "td-slider__tips is-active",
              style: _normalizeStyle(props.vertical ? { bottom: '' + _unref(data).innerStyle['height'] } : { left: _unref(data).innerStyle['width'] })
            }, _toDisplayString(props.formatTooltip(props.value)), 5))
          : _createCommentVNode("", true)
      ], 4),
      _createVNode(SliderButton, {
        class: _normalizeClass(_ctx.$props.class),
        ref_key: "button",
        ref: button,
        value: _unref(data).valueCache,
        disabled: props.disabled,
        onInput: handleUpdate,
        onRelease: handleRelease,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onUpdateInnerStyle: handleUpdateInnerStyle,
        onDragStart: handleSliderButtonDragStart,
        onDragEnd: handleSliderButtonDragEnd
      }, null, 8, ["class", "value", "disabled"])
    ])
  ], 2))
}
}

})